import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { FaxPrefixes } from '@frontend/tracking-prefixes';
import { theme } from '@frontend/theme';
import { PopoverMenuItem, Text, usePopoverMenu } from '@frontend/design-system';
import { FaxNumbersSelectPopover } from './fax-numbers-select-popover';

type Props = {
  faxNumbers: string[];
  selectedFaxNumbers: string[];
  selectFaxNumbers: (faxNumbers: string[]) => void;
};
export const FaxNumbersMenuItem = ({ faxNumbers, selectFaxNumbers, selectedFaxNumbers }: Props) => {
  const { t } = useTranslation('fax');
  const faxNumbersPopover = usePopoverMenu<HTMLButtonElement>({
    placement: 'right-start',
  });

  return (
    <>
      <PopoverMenuItem
        {...faxNumbersPopover.getTriggerProps()}
        css={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          svg: { fill: theme.colors.neutral50 },
          cursor: 'pointer',
          transition: 'background-color 150ms ease-in-out',
          overflow: 'hidden',
          gap: theme.spacing(2),
          padding: 0,
          marginTop: theme.spacing(-1),
        }}
        trackingId={`${FaxPrefixes.Filters}-fax-numbers`}
      >
        <div css={{ display: 'flex', gap: theme.spacing(1) }}>
          <Icon name='fax-number' size={24} color='light' />
          <Text>{t('Fax Number')}</Text>
        </div>
        <div css={{ display: 'flex', alignItems: 'center', gap: theme.spacing(1) }}>
          {selectedFaxNumbers?.length > 0 && (
            <Text
              size='small'
              css={{
                color: theme.colors.primary70,
                padding: theme.spacing(0.25, 0.5),
                borderRadius: theme.borderRadius.small,
                backgroundColor: theme.colors.primary10,
              }}
            >
              {selectedFaxNumbers?.length}
            </Text>
          )}
          <Icon name='alt-caret-right-tiny' color='light' />
        </div>
      </PopoverMenuItem>
      <FaxNumbersSelectPopover
        faxNumbers={faxNumbers}
        selectedFaxNumbers={selectedFaxNumbers}
        selectFaxNumbers={selectFaxNumbers}
        getMenuProps={faxNumbersPopover.getMenuProps}
        getItemProps={faxNumbersPopover.getItemProps}
      />
    </>
  );
};
